import { useModalDragConstraint } from "../../../components/Modal";
import type { TRangeSelection } from "../../useRangeSelectionChange";
import { useMemoModal } from "../../../components/Modal";
import { FormatColumn } from "./FormatColumn";
import type { TFormatTypes } from "../../cell-style/helpers";
import { FormatModalWrapper } from "./FormatModalWrapper";

const getModalTitle = (type: TFormatTypes) => {
  switch (type) {
    case "column":
      return "Format column";
    case "range":
      return "Format range";
    case "period":
      return "Format period";
    default:
      return "Format";
  }
};

export const useColumnSettingsModal = () => {
  const constraintRef = useModalDragConstraint();
  const modal = useMemoModal(
    (p: {
      active: "color" | "settings";
      selection: TRangeSelection;
      type: TFormatTypes;
      pageId: string;
      width?: number;
      height?: number;
    }) => {
      return (
        <FormatModalWrapper title={getModalTitle(p.type)} constrainRef={constraintRef} onClose={() => modal.close()}>
          <FormatColumn selection={p.selection} type={p.type} pageId={p.pageId} onClose={() => modal.close()} />
        </FormatModalWrapper>
      );
    },
  );

  return modal;
};
